import './heading.css' ;

const Heading = ({text}) => <div className="title-con"> <h2 className="left-title">{text}</h2> </div>

export default Heading ;